import React from 'react'

const Footer = () => {
  return (
    <div style={{marginTop:'10%',color:'grey'}}>
    <p style={{ fontFamily: "'Silkscreen', cursive"}}>@ChainLink Hackathon @2022</p>

    </div>
  )
}

export default Footer
